import { FieldType } from '@ngx-formly/material';

import { Component } from '@angular/core';

import { ISnSliderFormFieldConfig } from '../../interfaces/slider-form-field-config.interface';
import { ISnSliderTemplateOptions } from '../../interfaces/slider-template-options.interface';

@Component({
  selector: 'sn-slider-form-field',
  templateUrl: './slider.form-field.html',
  styleUrls: ['./slider.form-field.scss'],
})
export class SnSliderFormField extends FieldType<ISnSliderFormFieldConfig> {
  constructor() {
    super();
  }

  get templateOptions(): ISnSliderTemplateOptions {
    return this.field.templateOptions;
  }
}
